import React from 'react';

export default function ReportRenderer({ text }) {
  if (!text) return null;

  const lines = text.split('\n');
  const elements = [];
  let i = 0;

  while (i < lines.length) {
    const line = lines[i];

    // Markdown table
    if (line.trim().startsWith('|') && i + 1 < lines.length && lines[i+1].trim().match(/^\|[\s\-|]+\|$/)) {
      const headers = line.trim().split('|').filter(h => h.trim()).map(h => h.trim());
      i += 2; // skip separator row
      const rows = [];
      while (i < lines.length && lines[i].trim().startsWith('|')) {
        const cells = lines[i].trim().split('|').filter(c => c !== undefined).slice(1, -1).map(c => c.trim());
        rows.push(cells);
        i++;
      }
      elements.push(
        <div key={`table-${i}`} className="gm-report-table-wrap">
          <table className="gm-table">
            <thead>
              <tr>{headers.map((h, hi) => <th key={hi}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {rows.map((row, ri) => (
                <tr key={ri}>{row.map((cell, ci) => <td key={ci}>{cell}</td>)}</tr>
              ))}
            </tbody>
          </table>
        </div>
      );
      continue;
    }

    // H1/H2 headings
    if (line.startsWith('## ') || line.startsWith('# ')) {
      elements.push(
        <h2 key={i} style={{ fontSize:'1rem', fontWeight:800, color:'#1e293b', marginTop:20, marginBottom:6, borderBottom:'1px solid #e2e8f0', paddingBottom:4 }}>
          {line.replace(/^#+\s*/, '')}
        </h2>
      );
      i++; continue;
    }

    // H3
    if (line.startsWith('### ')) {
      elements.push(
        <h3 key={i} style={{ fontSize:'0.9rem', fontWeight:700, color:'#1e293b', marginTop:14, marginBottom:4 }}>
          {line.replace(/^###\s*/, '')}
        </h3>
      );
      i++; continue;
    }

    // Numbered list item
    if (line.match(/^\d+\.\s/)) {
      elements.push(
        <p key={i} style={{ fontSize:'0.875rem', lineHeight:1.7, color:'#334155', margin:'4px 0' }}>
          <strong>{line.match(/^\d+/)[0]}.</strong> {line.replace(/^\d+\.\s*/, '')}
        </p>
      );
      i++; continue;
    }

    // Bullet
    if (line.startsWith('- ') || line.startsWith('* ')) {
      elements.push(
        <p key={i} style={{ fontSize:'0.875rem', lineHeight:1.7, color:'#334155', margin:'3px 0', paddingLeft:16 }}>
          · {line.replace(/^[-*]\s*/, '')}
        </p>
      );
      i++; continue;
    }

    // Bold inline **text**
    if (line.trim() && line.includes('**')) {
      const parts = line.split('**');
      elements.push(
        <p key={i} style={{ fontSize:'0.875rem', lineHeight:1.75, color:'#334155', margin:'6px 0' }}>
          {parts.map((part, pi) => pi % 2 === 1 ? <strong key={pi}>{part}</strong> : part)}
        </p>
      );
      i++; continue;
    }

    // Empty line — spacer
    if (!line.trim()) {
      elements.push(<div key={i} style={{ height:8 }} />);
      i++; continue;
    }

    // Regular paragraph
    elements.push(
      <p key={i} style={{ fontSize:'0.875rem', lineHeight:1.75, color:'#334155', margin:'6px 0' }}>
        {line}
      </p>
    );
    i++;
  }

  return <div>{elements}</div>;
}
